import { post } from 'core_main/request';
import { PUBNUB_AUTH_ENDPOINT } from './constants';

export const createAuthForTrackingToken = () => {
  return post(PUBNUB_AUTH_ENDPOINT).then((response) => {
    return response;
  });
};
